export default __webpack_public_path__ + "static/indu-398206155d52c0ed6f28565e764bbfe7.jpg";